export default class UsageDataService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getMissingUsageData() {
    return this.$http.get('/api/usage/all_missing_usage');
  }

  getMissingQuarterUsageData() {
    return this.$http.get('/api/usage/all_missing_usage_current_qarter');
  }

  getQ4Value(productId, year) {
    return this.$http.get(`/api/usage/q4_value/${productId}/${year}`);
  }

  getMissingProductUsageData(productId) {
    return this.$http.get(`/api/usage/product_missing_usage/${productId}`);
  }

  updateMissingUsageData(usages) {
    return this.$http.post('/api/usage/update_missing_usage', {
      usages
    });
  }
}



// WEBPACK FOOTER //
// ./services/usage-data.service.js